import { render, staticRenderFns } from "./project-confirmed.vue?vue&type=template&id=460fcf16&scoped=true&"
import script from "./project-confirmed.vue?vue&type=script&lang=js&"
export * from "./project-confirmed.vue?vue&type=script&lang=js&"
import style0 from "./project-confirmed.vue?vue&type=style&index=0&id=460fcf16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460fcf16",
  null
  
)

export default component.exports